import React from 'react';
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css"


export default function SwaggerDoc() {
  return (
    <div style={{backgroundColor: "white"}}>
      <SwaggerUI
        url={`${process.env.PUBLIC_URL}/openapi.yaml`}
      />
    </div>
  );
}